import { render, staticRenderFns } from "./ServiceCenter.vue?vue&type=template&id=2b8aed4f&scoped=true"
import script from "./ServiceCenter.vue?vue&type=script&lang=js"
export * from "./ServiceCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8aed4f",
  null
  
)

export default component.exports